import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom'
import s from './questionAdminPage.module.css'
import QuestionAdminCard from "./QuestionCard/QuestionAdminCard";
import Loader from "../../Static/Loader/Loader";
import QuestionState from '../../State/QuestionState/QuestionState'
import {Link} from 'react-router-dom'
import QuestionCardDesctop from "./QuestionCardDesctop/QuestionCardDesctop";

 // isLoad={isLoad} progress={progress} loadQuizzes={loadQuizzes} quizzes={quizzes}
const QuestionAdminPage = (props) => {

    const [tasks, setTasks] = useState([])
    const [quizId, setQuizId] = useState({})
    const [currentTaskNumber, setCurrentTaskNumber] = useState({})
    const [toMobile, setToMobile] = useState(true)

    const {id} = useParams();

    useEffect(()=>{
        if(!props.isLoad){
            props.loadQuizzes()
        }else{
            const currentQuiz = props.quizzes.find(q=>q.id===id)
            setQuizId(currentQuiz.id)
            setCurrentTaskNumber(0)
            setTasks(currentQuiz.tasks)
            // console.log(currentQuiz.tasks[taskNumberFromProgress?taskNumberFromProgress])
        }
        if ( navigator.userAgent.indexOf('Android')>0 ||navigator.userAgent.indexOf('Android')>0 ||navigator.userAgent.indexOf('BlackBerry')>0 ||navigator.userAgent.indexOf('iPhone')>0 ||navigator.userAgent.indexOf('iPad')>0 ||navigator.userAgent.indexOf('iPod')>0 ||navigator.userAgent.indexOf('Opera Mini')>0 ||navigator.userAgent.indexOf('IEMobile')>0 ){
            setToMobile(true)
        }else
            setToMobile(false)
    },[props.isLoad])

    const nextTask=(n)=>{
        setCurrentTaskNumber(currentTaskNumber+n)
    }


    if(props.isLoad)
    return(
        <div className={s.wrapper}>
            <Link to={'../'}>
                <div className={s.btn_back_quiz}>ᐸ Вернуться к выбору квестов</div>
            </Link>
            {tasks.length>0?
            <>
                { toMobile?
                    <QuestionAdminCard currentTaskNumber={currentTaskNumber} task={tasks[currentTaskNumber]}
                                  nextTask={nextTask} nextTask={nextTask}
                                  setProgress={props.setProgress}
                                  isFinish={currentTaskNumber+1 === tasks.length}/>:
                    <QuestionCardDesctop currentTaskNumber={currentTaskNumber} task={tasks[currentTaskNumber]}
                                  nextTask={nextTask} checkAnswer={nextTask}
                                  setProgress={props.setProgress}
                                  isFinish={currentTaskNumber+1 === tasks.length}/>
                }
            </>:
            <div>В данном квесте пока нет вопросов</div>
            }
        </div>
    )
    else
        return <Loader/>
}

export default QuestionAdminPage;